// Models
import {
  AlertsHistogramPayload,
  DeleteValidationModelPayload,
  DetectionModelMetricsResponse,
  DetectionModelsActionTypes,
  DetectionModelsPerformance,
  DetectionModelTemplatesPayload,
  DetectionModelTemplatesResponse,
  DetectionModelValidation,
  EditingAdvancedDetectionModel,
  EditingSimpleDetectionModel,
  RetrieveValidationMetricsPayload,
  ScenarioConfigs,
  ValidateModelPayload,
  ValidateModelResponse,
} from 'app/modules/detectionModels/models';
import { DmObjectToFlag } from 'app/modules/rulesAdvanced/models';

// Utils
import { ActionsUnion, createAction } from 'app/shared/utils/action-helpers';

export const retrieveScenarioConfigs = () => {
  return createAction(DetectionModelsActionTypes.RETRIEVE_SCENARIO_CONFIGS);
};

export const retrieveScenarioConfigsSuccess = (payload: ScenarioConfigs) => {
  return createAction(
    DetectionModelsActionTypes.RETRIEVE_SCENARIO_CONFIGS_SUCCESS,
    payload,
  );
};

export const retrieveDetectionModelsPerformance = (
  payload: AlertsHistogramPayload,
) => {
  return createAction(
    DetectionModelsActionTypes.RETRIEVE_DETECTION_MODELS_PERFORMANCE,
    payload,
  );
};

export const retrieveDetectionModelsPerformanceSuccess = (
  payload: DetectionModelsPerformance,
) => {
  return createAction(
    DetectionModelsActionTypes.RETRIEVE_DETECTION_MODELS_PERFORMANCE_SUCCESS,
    payload,
  );
};

export const revalidateDetectionModel = (
  payload: ValidateModelPayload & { id: number },
) =>
  createAction(DetectionModelsActionTypes.REVALIDATE_DETECTION_MODEL, payload);

export const revalidateDetectionModelSuccess = (
  payload: ValidateModelResponse,
) =>
  createAction(
    DetectionModelsActionTypes.REVALIDATE_DETECTION_MODEL_SUCCESS,
    payload,
  );

/**
 * @deprecated Use useValidateRule instead
 */
export const validateDetectionModel = (payload: ValidateModelPayload) => {
  return createAction(
    DetectionModelsActionTypes.VALIDATE_DETECTION_MODEL,
    payload,
  );
};

export const validateDetectionModelSuccess = (
  payload: ValidateModelResponse,
) => {
  return createAction(
    DetectionModelsActionTypes.VALIDATE_DETECTION_MODEL_SUCCESS,
    payload,
  );
};

export const resetEditingModels = () =>
  createAction(DetectionModelsActionTypes.RESET_EDITING_DETECTION_MODELS);

export const resetModelValidation = () =>
  createAction(DetectionModelsActionTypes.RESET_MODEL_VALIDATION);

export const setEditingSimpleDetectionModel = (
  payload: EditingSimpleDetectionModel,
) =>
  createAction(
    DetectionModelsActionTypes.SET_EDITING_SIMPLE_DETECTION_MODEL,
    payload,
  );

export const setEditingAdvancedDetectionModel = (
  payload: EditingAdvancedDetectionModel,
) =>
  createAction(
    DetectionModelsActionTypes.SET_EDITING_ADVANCED_DETECTION_MODEL,
    payload,
  );

export const setEditingAdvancedDetectionModelObjectToFlag = (
  payload: DmObjectToFlag,
) =>
  createAction(
    DetectionModelsActionTypes.SET_EDITING_ADVANCED_DETECTION_MODEL_OBJECT_TO_FLAG,
    payload,
  );

// Validation Models
export const deleteValidationModel = (payload: DeleteValidationModelPayload) =>
  createAction(DetectionModelsActionTypes.DELETE_VALIDATION_MODEL, payload);

export const deleteValidationModelSuccess = () => {
  return createAction(
    DetectionModelsActionTypes.DELETE_VALIDATION_MODEL_SUCCESS,
  );
};

export const retrieveDetectionModelValidation = (id: number) =>
  createAction(
    DetectionModelsActionTypes.RETRIEVE_DETECTION_MODEL_VALIDATION,
    id,
  );

export const retrieveDetectionModelValidationSuccess = (
  response: DetectionModelValidation,
) =>
  createAction(
    DetectionModelsActionTypes.RETRIEVE_DETECTION_MODEL_VALIDATION_SUCCESS,
    response,
  );

export const retrieveDetectionModelValidationMetrics = (
  payload: RetrieveValidationMetricsPayload,
) =>
  createAction(
    DetectionModelsActionTypes.RETRIEVE_DETECTION_MODEL_VALIDATION_METRICS,
    payload,
  );

export const retrieveDetectionModelValidationMetricsSuccess = (
  response: DetectionModelMetricsResponse,
) =>
  createAction(
    DetectionModelsActionTypes.RETRIEVE_DETECTION_MODEL_VALIDATION_METRICS_SUCCESS,
    response,
  );

export const retrieveDetectionModelTemplates = (
  payload: DetectionModelTemplatesPayload,
) =>
  createAction(
    DetectionModelsActionTypes.RETRIEVE_DETECTION_MODEL_TEMPLATES,
    payload,
  );

export const retrieveDetectionModelTemplatesSuccess = (
  response: DetectionModelTemplatesResponse,
) =>
  createAction(
    DetectionModelsActionTypes.RETRIEVE_DETECTION_MODEL_TEMPLATES_SUCCESS,
    response,
  );

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ModelsActionsList = {
  retrieveScenarioConfigsSuccess,
  retrieveDetectionModelValidationSuccess,
  retrieveDetectionModelsPerformanceSuccess,
  validateDetectionModel,
  validateDetectionModelSuccess,
  setEditingSimpleDetectionModel,
  setEditingAdvancedDetectionModel,
  setEditingAdvancedDetectionModelObjectToFlag,
  resetEditingModels,
  resetModelValidation,
  retrieveDetectionModelValidationMetricsSuccess,
  retrieveDetectionModelTemplatesSuccess,
};

export type ModelsActions = ActionsUnion<typeof ModelsActionsList>;

export default ModelsActions;
